export App from './App/App';
export Accueil from './accueil/Accueil';
export Contact from './contact/Contact';
export Approche from './approche/Approche';
export Agence from './agence/Agence';
export Blogue from './blogue/Blogue';
export StrategieWeb from './strategieWeb/strategieWeb';
export ServiceConseil from './serviceConseil/serviceConseil';
export DeveloppementWeb from './developpementWeb/developpementWeb';
export Realisation from './singleRealisation/singleRealisation';
export Realisations from './realisations/realisations';
export SingleBlogue from './singleBlogue/singleBlogue';
export CategorieBlogue from './categorieBlogue/categorieBlogue';
export NotFoundPage from './notFoundPage';




// WEBPACK FOOTER //
// ./containers/index.js